const ACCOUNT_DRAWER_OPEN_EVENT = 'trashie:account-drawer-open';
const ACCOUNT_DRAWER_STATE_EVENT = 'trashie:account-drawer-state';
/** sessionStorage key: open account drawer on notifications tab (value: `notifications`) */
const ACCOUNT_DRAWER_NOTIFICATIONS_TAB_SESSION_KEY = 'trashie:accountDrawerNotificationsTab';
const TRACKING_DRAWER_OPEN_EVENT = 'trashie:tracking-drawer-open';
const TRACKING_DRAWER_STATE_EVENT = 'trashie:tracking-drawer-state';

export {
  ACCOUNT_DRAWER_NOTIFICATIONS_TAB_SESSION_KEY,
  ACCOUNT_DRAWER_STATE_EVENT,
  TRACKING_DRAWER_OPEN_EVENT,
  TRACKING_DRAWER_STATE_EVENT,
};
export default ACCOUNT_DRAWER_OPEN_EVENT;
